import { useRef, useState } from "react";
import { storyblokEditable } from "@storyblok/react";

const COUNTRIES = [
  { label: "Afghanistan", value: "AF" },
  { label: "Albania", value: "AL" },
  { label: "Algeria", value: "DZ" },
  { label: "Andorra", value: "AD" },
  { label: "Angola", value: "AO" },
  { label: "Antigua and Barbuda", value: "AG" },
  { label: "Argentina", value: "AR" },
  { label: "Armenia", value: "AM" },
  { label: "Australia", value: "AU" },
  { label: "Austria", value: "AT" },
  { label: "Azerbaijan", value: "AZ" },
  { label: "Bahamas", value: "BS" },
  { label: "Bahrain", value: "BH" },
  { label: "Bangladesh", value: "BD" },
  { label: "Barbados", value: "BB" },
  { label: "Belarus", value: "BY" },
  { label: "Belgium", value: "BE" },
  { label: "Belize", value: "BZ" },
  { label: "Benin", value: "BJ" },
  { label: "Bhutan", value: "BT" },
  { label: "Bolivia", value: "BO" },
  { label: "Bosnia and Herzegovina", value: "BA" },
  { label: "Botswana", value: "BW" },
  { label: "Brazil", value: "BR" },
  { label: "Brunei", value: "BN" },
  { label: "Bulgaria", value: "BG" },
  { label: "Burkina Faso", value: "BF" },
  { label: "Burundi", value: "BI" },
  { label: "Cabo Verde", value: "CV" },
  { label: "Cambodia", value: "KH" },
  { label: "Cameroon", value: "CM" },
  { label: "Canada", value: "CA" },
  { label: "Central African Republic", value: "CF" },
  { label: "Chad", value: "TD" },
  { label: "Chile", value: "CL" },
  { label: "China", value: "CN" },
  { label: "Colombia", value: "CO" },
  { label: "Comoros", value: "KM" },
  { label: "Congo", value: "CG" },
  { label: "Costa Rica", value: "CR" },
  { label: "Croatia", value: "HR" },
  { label: "Cuba", value: "CU" },
  { label: "Cyprus", value: "CY" },
  { label: "Czech Republic", value: "CZ" },
  { label: "Democratic Republic of the Congo", value: "CD" },
  { label: "Denmark", value: "DK" },
  { label: "Djibouti", value: "DJ" },
  { label: "Dominica", value: "DM" },
  { label: "Dominican Republic", value: "DO" },
  { label: "Ecuador", value: "EC" },
  { label: "Egypt", value: "EG" },
  { label: "El Salvador", value: "SV" },
  { label: "Equatorial Guinea", value: "GQ" },
  { label: "Eritrea", value: "ER" },
  { label: "Estonia", value: "EE" },
  { label: "Eswatini", value: "SZ" },
  { label: "Ethiopia", value: "ET" },
  { label: "Fiji", value: "FJ" },
  { label: "Finland", value: "FI" },
  { label: "France", value: "FR" },
  { label: "Gabon", value: "GA" },
  { label: "Gambia", value: "GM" },
  { label: "Georgia", value: "GE" },
  { label: "Germany", value: "DE" },
  { label: "Ghana", value: "GH" },
  { label: "Greece", value: "GR" },
  { label: "Grenada", value: "GD" },
  { label: "Guatemala", value: "GT" },
  { label: "Guinea", value: "GN" },
  { label: "Guinea-Bissau", value: "GW" },
  { label: "Guyana", value: "GY" },
  { label: "Haiti", value: "HT" },
  { label: "Honduras", value: "HN" },
  { label: "Hungary", value: "HU" },
  { label: "Iceland", value: "IS" },
  { label: "India", value: "IN" },
  { label: "Indonesia", value: "ID" },
  { label: "Iran", value: "IR" },
  { label: "Iraq", value: "IQ" },
  { label: "Ireland", value: "IE" },
  { label: "Israel", value: "IL" },
  { label: "Italy", value: "IT" },
  { label: "Jamaica", value: "JM" },
  { label: "Japan", value: "JP" },
  { label: "Jordan", value: "JO" },
  { label: "Kazakhstan", value: "KZ" },
  { label: "Kenya", value: "KE" },
  { label: "Kiribati", value: "KI" },
  { label: "Kuwait", value: "KW" },
  { label: "Kyrgyzstan", value: "KG" },
  { label: "Laos", value: "LA" },
  { label: "Latvia", value: "LV" },
  { label: "Lebanon", value: "LB" },
  { label: "Lesotho", value: "LS" },
  { label: "Liberia", value: "LR" },
  { label: "Libya", value: "LY" },
  { label: "Liechtenstein", value: "LI" },
  { label: "Lithuania", value: "LT" },
  { label: "Luxembourg", value: "LU" },
  { label: "Madagascar", value: "MG" },
  { label: "Malawi", value: "MW" },
  { label: "Malaysia", value: "MY" },
  { label: "Maldives", value: "MV" },
  { label: "Mali", value: "ML" },
  { label: "Malta", value: "MT" },
  { label: "Marshall Islands", value: "MH" },
  { label: "Mauritania", value: "MR" },
  { label: "Mauritius", value: "MU" },
  { label: "Mexico", value: "MX" },
  { label: "Micronesia", value: "FM" },
  { label: "Moldova", value: "MD" },
  { label: "Monaco", value: "MC" },
  { label: "Mongolia", value: "MN" },
  { label: "Montenegro", value: "ME" },
  { label: "Morocco", value: "MA" },
  { label: "Mozambique", value: "MZ" },
  { label: "Myanmar", value: "MM" },
  { label: "Namibia", value: "NA" },
  { label: "Nauru", value: "NR" },
  { label: "Nepal", value: "NP" },
  { label: "Netherlands", value: "NL" },
  { label: "New Zealand", value: "NZ" },
  { label: "Nicaragua", value: "NI" },
  { label: "Niger", value: "NE" },
  { label: "Nigeria", value: "NG" },
  { label: "North Korea", value: "KP" },
  { label: "North Macedonia", value: "MK" },
  { label: "Norway", value: "NO" },
  { label: "Oman", value: "OM" },
  { label: "Pakistan", value: "PK" },
  { label: "Palau", value: "PW" },
  { label: "Palestine", value: "PS" },
  { label: "Panama", value: "PA" },
  { label: "Papua New Guinea", value: "PG" },
  { label: "Paraguay", value: "PY" },
  { label: "Peru", value: "PE" },
  { label: "Philippines", value: "PH" },
  { label: "Poland", value: "PL" },
  { label: "Portugal", value: "PT" },
  { label: "Qatar", value: "QA" },
  { label: "Romania", value: "RO" },
  { label: "Russia", value: "RU" },
  { label: "Rwanda", value: "RW" },
  { label: "Saint Kitts and Nevis", value: "KN" },
  { label: "Saint Lucia", value: "LC" },
  { label: "Saint Vincent and the Grenadines", value: "VC" },
  { label: "Samoa", value: "WS" },
  { label: "San Marino", value: "SM" },
  { label: "Sao Tome and Principe", value: "ST" },
  { label: "Saudi Arabia", value: "SA" },
  { label: "Senegal", value: "SN" },
  { label: "Serbia", value: "RS" },
  { label: "Seychelles", value: "SC" },
  { label: "Sierra Leone", value: "SL" },
  { label: "Singapore", value: "SG" },
  { label: "Slovakia", value: "SK" },
  { label: "Slovenia", value: "SI" },
  { label: "Solomon Islands", value: "SB" },
  { label: "Somalia", value: "SO" },
  { label: "South Africa", value: "ZA" },
  { label: "South Korea", value: "KR" },
  { label: "South Sudan", value: "SS" },
  { label: "Spain", value: "ES" },
  { label: "Sri Lanka", value: "LK" },
  { label: "Sudan", value: "SD" },
  { label: "Suriname", value: "SR" },
  { label: "Sweden", value: "SE" },
  { label: "Switzerland", value: "CH" },
  { label: "Syria", value: "SY" },
  { label: "Taiwan", value: "TW" },
  { label: "Tajikistan", value: "TJ" },
  { label: "Tanzania", value: "TZ" },
  { label: "Thailand", value: "TH" },
  { label: "Timor-Leste", value: "TL" },
  { label: "Togo", value: "TG" },
  { label: "Tonga", value: "TO" },
  { label: "Trinidad and Tobago", value: "TT" },
  { label: "Tunisia", value: "TN" },
  { label: "Turkey", value: "TR" },
  { label: "Turkmenistan", value: "TM" },
  { label: "Tuvalu", value: "TV" },
  { label: "Uganda", value: "UG" },
  { label: "Ukraine", value: "UA" },
  { label: "United Arab Emirates", value: "AE" },
  { label: "United Kingdom", value: "GB" },
  { label: "United States", value: "US" },
  { label: "Uruguay", value: "UY" },
  { label: "Uzbekistan", value: "UZ" },
  { label: "Vanuatu", value: "VU" },
  { label: "Vatican City", value: "VA" },
  { label: "Venezuela", value: "VE" },
  { label: "Vietnam", value: "VN" },
  { label: "Yemen", value: "YE" },
  { label: "Zambia", value: "ZM" },
  { label: "Zimbabwe", value: "ZW" },
];

const US_STATES = [
  { label: "Alabama", value: "AL" },
  { label: "Alaska", value: "AK" },
  { label: "Arizona", value: "AZ" },
  { label: "Arkansas", value: "AR" },
  { label: "California", value: "CA" },
  { label: "Colorado", value: "CO" },
  { label: "Connecticut", value: "CT" },
  { label: "Delaware", value: "DE" },
  { label: "Florida", value: "FL" },
  { label: "Georgia", value: "GA" },
  { label: "Hawaii", value: "HI" },
  { label: "Idaho", value: "ID" },
  { label: "Illinois", value: "IL" },
  { label: "Indiana", value: "IN" },
  { label: "Iowa", value: "IA" },
  { label: "Kansas", value: "KS" },
  { label: "Kentucky", value: "KY" },
  { label: "Louisiana", value: "LA" },
  { label: "Maine", value: "ME" },
  { label: "Maryland", value: "MD" },
  { label: "Massachusetts", value: "MA" },
  { label: "Michigan", value: "MI" },
  { label: "Minnesota", value: "MN" },
  { label: "Mississippi", value: "MS" },
  { label: "Missouri", value: "MO" },
  { label: "Montana", value: "MT" },
  { label: "Nebraska", value: "NE" },
  { label: "Nevada", value: "NV" },
  { label: "New Hampshire", value: "NH" },
  { label: "New Jersey", value: "NJ" },
  { label: "New Mexico", value: "NM" },
  { label: "New York", value: "NY" },
  { label: "North Carolina", value: "NC" },
  { label: "North Dakota", value: "ND" },
  { label: "Ohio", value: "OH" },
  { label: "Oklahoma", value: "OK" },
  { label: "Oregon", value: "OR" },
  { label: "Pennsylvania", value: "PA" },
  { label: "Rhode Island", value: "RI" },
  { label: "South Carolina", value: "SC" },
  { label: "South Dakota", value: "SD" },
  { label: "Tennessee", value: "TN" },
  { label: "Texas", value: "TX" },
  { label: "Utah", value: "UT" },
  { label: "Vermont", value: "VT" },
  { label: "Virginia", value: "VA" },
  { label: "Washington", value: "WA" },
  { label: "West Virginia", value: "WV" },
  { label: "Wisconsin", value: "WI" },
  { label: "Wyoming", value: "WY" },
  { label: "District of Columbia", value: "DC" },
];

const encode = (data) =>
  Object.keys(data)
    .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(data[key] ?? "")}`)
    .join("&");

const getUTMParams = () => {
  const params = new URLSearchParams(window.location.search);
  return {
    utm_source: params.get("utm_source") || "",
    utm_medium: params.get("utm_medium") || "",
    utm_campaign: params.get("utm_campaign") || "",
    utm_content: params.get("utm_content") || "",
    utm_term: params.get("utm_term") || "",
  };
};

const ContactUsForm = ({ blok, onSuccess }) => {
  const [status, setStatus] = useState({ state: "idle", message: "" });
  const [form, setForm] = useState({
    first_name: "",
    last_name: "",
    email: "",
    company: "",
    title: "",
    phone: "",
    country: "",
    state: "",
    comment: "",
    consent: false,
    website: "",
    ...getUTMParams(),
  });

  const statusRef = useRef(null);

  const scrollStatusIntoView = () => {
    requestAnimationFrame(() => {
      statusRef.current?.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    });
  };

  const formImageSrc = blok?.form_image?.filename || "";
  const formImageAlt = blok?.form_image_alt || blok?.form_image?.alt || "Contact form image";
  const hasFormImage = !!formImageSrc;

  const isUSSelected = form.country === "US";

  const onChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm((prev) => {
      const next = {
        ...prev,
        [name]: type === "checkbox" ? checked : value,
      };
      if (name === "country" && value !== "United States") {
        next.state = "";
      }
      return next;
    });
  };

  const validate = () => {
    if (!form.first_name.trim()) return "First name is required.";
    if (!form.last_name.trim()) return "Last name is required.";
    if (!form.email.trim()) return "Business email is required.";
    if (!/^\S+@\S+\.\S+$/.test(form.email)) return "Please enter a valid email.";
    if (!form.company.trim()) return "Company is required.";
    if (!form.title.trim()) return "Job title is required.";
    if (!form.phone.trim()) return "Business phone is required.";
    if (!form.country.trim()) return "Country/Region is required.";
    if (isUSSelected && !form.state.trim()) return "State is required for United States.";
    if ((form.comment || "").length > 1000) return "Comment must be 1000 characters or fewer.";
    if (!form.consent) return "You must agree to the terms.";
    return "";
  };

  const onSubmit = async (e) => {
    e.preventDefault();

    if (form.website) return;

    const error = validate();
    if (error) {
      setStatus({ state: "error", message: error });
      scrollStatusIntoView();
      return;
    }

    setStatus({ state: "submitting", message: "" });
    scrollStatusIntoView();

    const pardotData = new URLSearchParams({
      first_name: form.first_name,
      last_name: form.last_name,
      email: form.email,
      company: form.company,
      title: form.title,
      phone: form.phone,
      country: form.country,
      state: isUSSelected ? form.state : "",
      comment: form.comment,
      consent: form.consent ? "true" : "false",
      utm_source: form.utm_source,
      utm_medium: form.utm_medium,
      utm_campaign: form.utm_campaign,
      utm_content: form.utm_content,
      utm_term: form.utm_term,
    });

const isPardotEnabled = process.env.REACT_APP_DISABLE_PARDOT !== "true";

// dev environment test
if (isPardotEnabled) {
  try {
    await fetch("https://bb.blackberry.com/l/191232/2026-04-15/n8trff", {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: pardotData.toString(),
      mode: "no-cors",
    });
  } catch (err) {
    console.error("Pardot submission error:", err);
  }
} else {
  console.log("[DEV] Pardot submission skipped – REACT_APP_DISABLE_PARDOT=true");
}

    const payload = {
      "form-name": "contact-us-prod",
      "bot-field": form.website,
      first_name: form.first_name,
      last_name: form.last_name,
      email: form.email,
      company: form.company,
      title: form.title,
      phone: form.phone,
      country: form.country,
      state: isUSSelected ? form.state : "",
      comment: form.comment,
      consent: String(form.consent),
      utm_source: form.utm_source,
      utm_medium: form.utm_medium,
      utm_campaign: form.utm_campaign,
      utm_content: form.utm_content,
      utm_term: form.utm_term,
      pageUrl: window.location.href,
      formId: blok.form_id || "contact_us_form",
    };

    try {
      const netlifyRes = await fetch("/", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: encode(payload),
      });

      if (!netlifyRes.ok) throw new Error(`Submission failed (HTTP ${netlifyRes.status})`);

      setStatus({
        state: "success",
        message: blok.success_message || "Thanks! We'll be in touch.",
      });

      // Notify parent (e.g. ResourcesCards) that submission succeeded.
      // The parent is responsible for opening the video — doing it here
      // would require passing the URL back through props unnecessarily.
      if (onSuccess) {
        onSuccess();
      }

      scrollStatusIntoView();

      setForm({
        first_name: "",
        last_name: "",
        email: "",
        company: "",
        title: "",
        phone: "",
        country: "",
        state: "",
        comment: "",
        consent: false,
        website: "",
      });
    } catch (err) {
      setStatus({
        state: "error",
        message: (err instanceof Error ? err.message : null) || "Something went wrong.",
      });
      scrollStatusIntoView();
    }
  };

  return (
    <section {...storyblokEditable(blok)} className="w-full">
      <div className={`${hasFormImage ? "max-w-6xl" : "max-w-4xl"} mx-auto px-6 py-12`}>
        <div className={hasFormImage ? "grid grid-cols-1 md:grid-cols-2 md:gap-12 items-start" : ""}>
          <div>
            <h2 className="text-1xl font-medium mb-6">
              {blok.headline ||
                "We get it, your business has specific requirements. Contact the BlackBerry Radar team today to learn more about how BlackBerry Radar asset tracking can help improve your operations."}
            </h2>

            <div ref={statusRef} className="mb-6 min-h-[28px]">
              {status.state !== "idle" ? (
                status.state === "success" ? (
                  <p className="text-green-700">{status.message}</p>
                ) : status.state === "error" ? (
                  <p className="text-red-700">{status.message}</p>
                ) : (
                  <p>Submitting…</p>
                )
              ) : null}
            </div>

            <form
              name="contact-us-prod"
              method="POST"
              data-netlify="true"
              netlify-honeypot="bot-field"
              onSubmit={onSubmit}
              className="space-y-4"
            >
              <input type="hidden" name="form-name" value="contact-us-prod" />

              <input
                type="text"
                name="bot-field"
                value={form.website}
                onChange={(e) => setForm((f) => ({ ...f, website: e.target.value }))}
                autoComplete="off"
                tabIndex={-1}
                className="hidden"
              />

              {[
                ["first_name", "First name*", "text"],
                ["last_name", "Last name*", "text"],
                ["email", "Business Email*", "email"],
                ["company", "Company*", "text"],
                ["title", "Job title*", "text"],
                ["phone", "Business Phone*", "tel"],
              ].map(([name, label, type]) => (
                <div key={name}>
                  <label className="block text-sm font-medium mb-1" htmlFor={name}>
                    {label}
                  </label>
                  <input
                    id={name}
                    name={name}
                    type={type}
                    value={form[name]}
                    onChange={onChange}
                    className="w-full border rounded-md px-3 py-2"
                  />
                </div>
              ))}

              <div>
                <label className="block text-sm font-medium mb-1" htmlFor="country">
                  Country/Region*
                </label>
                <select
                  id="country"
                  name="country"
                  value={form.country}
                  onChange={onChange}
                  className="w-full border rounded-md px-3 py-2"
                >
                  <option value="">Select a country</option>
                  {COUNTRIES.map((c) => (
                    <option key={c.value} value={c.value}>
                      {c.label}
                    </option>
                  ))}
                </select>
              </div>

              {isUSSelected && (
                <div>
                  <label className="block text-sm font-medium mb-1" htmlFor="state">
                    State*
                  </label>
                  <select
                    id="state"
                    name="state"
                    value={form.state}
                    onChange={onChange}
                    className="w-full border rounded-md px-3 py-2"
                  >
                    <option value="">Select a state</option>
                    {US_STATES.map((s) => (
                      <option key={s.value} value={s.value}>
                        {s.label}
                      </option>
                    ))}
                  </select>
                </div>
              )}

              <div>
                <label className="block text-sm font-medium mb-1" htmlFor="businessChallengeYouNeedToSolve">
                  Business Challenge You Need to Solve
                </label>
                <textarea
                  id="comment"
                  name="comment"
                  value={form.comment}
                  onChange={onChange}
                  maxLength={1000}
                  rows={5}
                  className="w-full border rounded-md px-3 py-2 resize-y"
                  placeholder="Optional (max 1000 characters)"
                />
                <div className="mt-1 text-xs text-gray-500">
                  {form.comment.length}/1000
                </div>
              </div>

              <div className="pt-4 border-t">
                <p className="text-sm mb-3">
                  By registering, I agree to the processing of my personal data by BlackBerry in accordance with BlackBerry's{" "}
                  <a
                    href="https://www.blackberry.com/en/legal/privacy-notice"
                    className="underline hover:opacity-70"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Privacy Policy
                  </a>.
                </p>
                <label className="flex items-start gap-3 text-sm">
                  <input
                    type="checkbox"
                    name="consent"
                    checked={form.consent}
                    onChange={onChange}
                    className="mt-1"
                  />
                  <span>
                    {blok.terms_label ||
                      "By submitting this form, I agree to receive email communications about products, services and events from BlackBerry and its affiliates. I understand that I can unsubscribe at any time."}
                  </span>
                </label>
              </div>

              <button
                type="submit"
                disabled={status.state === "submitting"}
                className="inline-flex items-center justify-center rounded-full px-6 py-3 font-semibold bg-blue-600 text-white disabled:opacity-50"
              >
                {blok.submit_label || "REGISTER"}
              </button>
            </form>
          </div>

          {hasFormImage && (
            <div className="hidden md:flex items-center justify-center">
              <div className="rounded-2xl overflow-hidden shadow-sm w-[min(571px,100%)] aspect-square shrink-0">
                <img
                  src={formImageSrc}
                  alt={formImageAlt}
                  className="w-full h-full object-cover"
                  loading="eager"
                  decoding="async"
                  width="571"
                  height="571"
                />
              </div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default ContactUsForm;